import { lazy } from 'react';
import AddServiceRequest from '../pages/AddServiceRequest.page';
import OrderDetailsPage from '../pages/OrderDetailsPage';

// ----------------------------------------------------------------------

const OrdersPage = lazy(() => import('../pages/Order.page'));

// ----------------------------------------------------------------------

const OrderListRoutes = [
    {
        path: '/orders',
        children: [
            { element: <OrdersPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: '/orders/service-request',
                element: <AddServiceRequest />,
                layout: 'default',
                isAuthReq: true,
            },
            { path: 'order-list/:id', element: <OrderDetailsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { OrderListRoutes };
